import { NavLink } from "react-router-dom";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/directory", label: "Directory" },
  { to: "/map", label: "Global Map" },
  { to: "/about", label: "About" }
];

const Layout = ({ children }) => (
  <div className="min-h-screen bg-brand-night text-slate-100">
    <header className="sticky top-0 z-40 border-b border-brand-ink/40 bg-brand-night/95 backdrop-blur">
      <div className="page-wrapper flex flex-wrap items-center justify-between gap-4 py-4">
        <NavLink to="/" className="flex items-center gap-3 text-slate-100">
          <div className="relative flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-primary text-base font-black text-brand-night shadow-[0_8px_20px_rgba(0,0,0,0.4)]">
            MD
          </div>
          <div className="space-y-0.5">
            <p className="font-display text-2xl leading-none">Member Discovery</p>
            <p className="text-xs uppercase tracking-[0.35em] text-slate-500">Guild ecosystem</p>
          </div>
        </NavLink>

        <nav className="flex flex-wrap items-center gap-2 text-sm sm:text-base">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 font-semibold transition ${
                  isActive ? "bg-brand-primary/30 text-slate-100" : "text-brand-steel hover:text-slate-100"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <NavLink
            to="/submit"
            className="rounded-full bg-brand-secondary px-5 py-2 text-sm font-semibold text-brand-night transition hover:bg-brand-sun"
          >
            Submit
          </NavLink>
        </nav>
      </div>
    </header>

    <main className="py-10">
      <div className="page-wrapper space-y-14">{children}</div>
    </main>

    <footer className="border-t border-brand-ink/40 bg-brand-midnight/90 py-10">
      <div className="page-wrapper grid gap-8 text-sm text-slate-400 md:grid-cols-3">
        <div>
          <p className="font-display text-lg text-slate-100">Member Discovery</p>
          <p className="mt-2 text-slate-400">Cross-platform guild maps curated for active, verified communities.</p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-500">Navigate</p>
          <ul className="mt-3 space-y-2">
            <li>
              <NavLink to="/" className="transition hover:text-slate-100">
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/directory" className="transition hover:text-slate-100">
                Directory
              </NavLink>
            </li>
            <li>
              <NavLink to="/map" className="transition hover:text-slate-100">
                Global Map
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" className="transition hover:text-slate-100">
                About
              </NavLink>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-500">Legal</p>
          <ul className="mt-3 space-y-2">
            <li>
              <NavLink to="/terms" className="transition hover:text-slate-100">
                Terms of Service
              </NavLink>
            </li>
            <li>
              <NavLink to="/privacy" className="transition hover:text-slate-100">
                Privacy Policy
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
      <p className="mt-8 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Member Discovery. All rights reserved.
      </p>
    </footer>
  </div>
);

export default Layout;
